// calls all apis for ya

import Axios from 'axios';
import {
  apiBaseUrl,
  creativeGenerationApiBaseUrl,
  phpApiBaseUrl,
  CONTEXT,
  apiFileUploadBaseUrl,
  authBaseUrl,
  demoTenantBaseUrl,
  demoTenantIds,
  apiDruidBaseUrl
} from '../constants/configuration';

// const TYPE_JSON = 'application/json';
const TYPE_JSON = 'application/json;charset=UTF-8';

export const buildAPIInstance = ({auth = false,isPhpApi = false,multipart = false,isCreativeGenerationApi = false,contenttype = TYPE_JSON,isAudienceDruid = false}) => {

  let demoTenant = false;
  let preSignInData = JSON.parse(localStorage.getItem("PreSignInState"));
  if (preSignInData && preSignInData.tenantId) {
    if (demoTenantIds.includes(preSignInData.tenantId)) {
      demoTenant = true
    }
  }

  // wait for valid base url
  const objAxios = Axios.create({
    baseURL: multipart ? apiFileUploadBaseUrl : auth? authBaseUrl: isPhpApi ? phpApiBaseUrl: isCreativeGenerationApi? creativeGenerationApiBaseUrl: isAudienceDruid? apiDruidBaseUrl: demoTenant? demoTenantBaseUrl: apiBaseUrl,
    headers: {
       domain: window.location.origin,
      // domain: "https://devbeki.torcai.com",
      // domain: "https://stageoneaudience.torcai.com",
      // domain: "https://bekistage.torcai.com",
      // domain: "https://oneaudience.torcai.com",
      //domain: "https://devoutcome.torcai.com",
      //domain: "https://stagemoutcome.torcai.com",
      common: {
        Accept: TYPE_JSON,
        'Content-Type': contenttype
      },
      post: {
        'Content-Type': TYPE_JSON
      }
    },
    transformResponse: [function (data) {
      if (data === undefined || data === null) {
        return data;
      }

      if (typeof data !== 'string') {
        return data;
      }

      if (data.trim() === '') {
        return null;
      }

      // if (data) {
      //   try {
      //     const newdata = JSON.parse(data);
      //     if (newdata ? (newdata.responseCode && newdata.responseCode.desc === 'Not authorised') : (newdata.responeCode && newdata.responeCode.msg === 'Invalid User Token')) {
      //       localStorage.clear();
      //       window.location.href = `${CONTEXT}`;
      //       throw new Error('token expired');
      //     }
      //   } catch (err) {
      //     return data;
      //   }
      // }
      if (data) {
        try {
          const newdata = JSON.parse(data);
          // debugger;
          if (newdata ? (newdata.responseCode && (newdata.responseCode.desc === 'Not authorised' || newdata.responseCode.msg === 'Invalid User Token' || newdata.responseCode.msg == 'Not Authorised')) || (newdata.responeCode && (newdata.responeCode.desc === 'Not authorised' || newdata.responeCode.msg === 'Invalid User Token')) : (newdata.responeCode && newdata.responeCode.msg === 'Invalid User Token')) {
            localStorage.clear();
            window.location.href = `${CONTEXT}`;
            throw new Error('token expired');
          }
        } catch (err) {
          return data;
        }
      }
      return JSON.parse(data);
    }],


  });

  return objAxios;
};

const client = (params = {}) => buildAPIInstance(params);

export default client;
